module.exports = __webpack_public_path__ + "static/4-f4410d2f819390c08fb16437e3b661df.jpg";